import { Component, Inject, Input, OnInit, PLATFORM_ID, SimpleChange, ViewChild } from '@angular/core';
import { SwiperConfigInterface, SwiperDirective, SwiperPaginationInterface } from 'src/app/theme/components/swiper/swiper.module';
import { AppSettings, Settings } from '../../app.settings';

import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
import { FasteignService } from 'src/app/components/services/api/fasteign/fasteign.service';
import { NotandiService } from 'src/app/components/services/api/notandi/notandi.service';
import { epilogExtractApartmentIdentity, epilogExtractHeightNumber } from 'src/app/helpers/epilogDecode';
import { opidHusString } from 'src/app/helpers/opidHus';
import { formatPriceString, thousandSeparator } from 'src/app/helpers/thousandSeparator';
import { AccountsLoginRes } from 'src/app/interfaces/CRUDL/read/AccountsLoginRes';
import { ExposedThjodskraLeitaFasteignRes } from 'src/app/interfaces/responses/Exposed/exposedThjodskraLeitaFasteignRes';
import { environment } from 'src/environments/environment';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-property-item-sold',
  templateUrl: './property-item-sold.component.html',
  styleUrls: ['./property-item-sold.component.scss']
})
export class PropertyItemSoldComponent implements OnInit {
  @Input() fasteign: ExposedThjodskraLeitaFasteignRes;
  @Input() viewType: string = "grid";
  @Input() viewColChanged: boolean = false;
  @Input() fullWidthPage: boolean = true;
  @Input() pageType: string = 'kaupsagan';
  @Input() mblInject: boolean = false;

  public column: number = 4;
  environment = environment;

  public today: Date = new Date();

  userDetails: AccountsLoginRes;

  opidHusFilterDate: Date;
  public isBrowser: boolean;
  public isServer: boolean;

  // public address:string;
  @ViewChild(SwiperDirective) directiveRef: SwiperDirective;
  public config: SwiperConfigInterface = {};
  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true
  };
  public settings: Settings;
  constructor(public appSettings: AppSettings, public appService: AppService, private notandiService: NotandiService, @Inject(PLATFORM_ID) platformId: Object, private fasteignService: FasteignService, private snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;
    this.isBrowser = isPlatformBrowser(platformId);
    this.isServer = isPlatformServer(platformId);

    if (this.isBrowser) {
      try {
        this.notandiService.userDetails.subscribe(userDetails => this.userDetails = userDetails);
      } catch { }
    }
  }

  ngOnInit() {
    var now = new Date();
    now.setHours(now.getHours() + 1);
    this.opidHusFilterDate = now;
    this.startLoadingAnimation();
  }

  formatDate(date: Date) {
    return moment(date).format('DD.MM.YYYY, [kl.] HH:mm');
  }

  formatVerd(numberString: string) {
    return formatPriceString(numberString.toString());
  }

  ngAfterViewInit() {
    this.initCarousel();
    this.config = {
      observer: false,
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: true,
      preloadImages: true,
      lazy: {
        loadPrevNext: true, // pre-loads the next image to avoid showing a loading placeholder if possible
        loadPrevNextAmount: 2 //or, if you wish, preload the next 2 images
      }
    };
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.viewColChanged) {
      this.getColumnCount(changes.viewColChanged.currentValue);
      if (!changes.viewColChanged.isFirstChange()) {
      }
    }
  }

  public getColumnCount(value) {
    if (value == 25) {
      this.column = 4;
    }
    else if (value == 33.3) {
      this.column = 3;
    }
    else if (value == 50) {
      this.column = 2
    }
    else {
      this.column = 1;
    }
  }

  public getStatusBgColor(status) {
    switch (status) {
      case 'For Sale':
        return '#558B2F';
      case 'For Rent':
        return '#1E88E5';
      case 'Open House':
        return '#009688';
      case 'No Fees':
        return '#FFA000';
      case 'Hot Offer':
        return '#F44336';
      case 'Sold':
        return '#000';
      default:
        return '#01579B';
    }
  }

  public opidHusString(fra, til) {
    return opidHusString(new Date(fra), new Date(til));
  }

  public initCarousel() {
    this.config = {
      slidesPerView: 1,
      spaceBetween: 0,
      keyboard: false,
      navigation: true,
      pagination: this.pagination,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      nested: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false
      // },
      speed: 500,
      effect: "slide"
    }
  }

  getFermetraverdKaupsamningur(fasteign): string {
    return thousandSeparator((Math.ceil(fasteign?.kaupverd * 1000 / fasteign?.einflm).toString()));
  }

  getFermetraverdAuglysing(fasteign): string {
    return thousandSeparator((Math.ceil(fasteign?.AuglystVerd / fasteign?.Kaupskra?.einflm).toString()));
  }

  formatVerdmatSqm(verdmatSqm: number): string {
    if (!verdmatSqm) return '';

    const flooredValue = Math.floor(verdmatSqm * 100) / 100; // Fjarlægir síðustu tvo aukastafina
    const newValue = Math.floor(flooredValue) * 100; // Skipta út síðustu tveimur fyrir 00
    return newValue.toFixed(0) + '0 kr./m²'; // Bætir við einu 0 í lokin
  }

  epilogExtractHeightNumber(epilogNumber: string) {
    return epilogExtractHeightNumber(epilogNumber);
  }

  epilogExtractApartmentIdentity(epilogNumber: string) {
    return epilogExtractApartmentIdentity(epilogNumber);
  }

  loadingTextAuglysingasaga = 'Kanna auglýsingasögu';
  loadingTextVerdmat = 'Reikna verðmat';
  private dots = 0;
  private interval: any;

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  startLoadingAnimation() {
    this.interval = setInterval(() => {
      this.dots = (this.dots + 1) % 4; // Telur frá 0 til 3
      this.loadingTextAuglysingasaga = 'Kanna auglýsingasögu ' + '.'.repeat(this.dots);
      this.loadingTextVerdmat = 'Reikna verðmat ' + '.'.repeat(this.dots);
    }, 500); // Breytir punktunum á hálfri sekúndu fresti
  }

}
